import { BaseController } from '~/utils/base-controller';

export default class KtableWidgetController extends BaseController {
	/* @ngInject */
	// eslint-disable-next-line no-useless-constructor
	/**
	 * @param {import("angular").auto.IInjectorService} $injector
	 */
	constructor($injector) {
		super($injector);
		/** @type {?import('~/pages/dashboard/dashboard.controller').default} */
		this.parent = null;

		/** @type {any} */
		this.widget = undefined;
	}

	$onInit() {
		if (this.widget?.tableOptions) {
			this.widget.tableOptions.widget = this.widget.options;
		}
	}
}
